// extracted by mini-css-extract-plugin
export default {"search_container":"searchChat_search_container__LTIGJ","search_input":"searchChat_search_input__Pu4Zv","search_input_icon":"searchChat_search_input_icon__lqUEE"};